/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import type { AccountsPayablePaymentWithExpenseData, GetByLinkedFlowParams } from '../dto'
import { HttpClient, RequestParams } from './http-client'

export class ApiPaymentDetailsControllerV2<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * No description
   *
   * @tags api-payment-details-controller-v-2
   * @name GetById6
   * @request GET:/api/v2/payment-details/accounts-payable/{id}
   */
  getById = (id: string, params: RequestParams = {}) =>
    this.http.request<AccountsPayablePaymentWithExpenseData, any>({
      path: `/v2/payment-details/accounts-payable/${id}`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getByIdPath = '/v2/payment-details/accounts-payable/${id}'
  static getByIdMethod = 'GET'
  /**
   * No description
   *
   * @tags api-payment-details-controller-v-2
   * @name DownloadInvoiceFile
   * @request GET:/api/v2/payment-details/accounts-payable/{id}/invoice/file
   */
  downloadInvoiceFile = (id: string, params: RequestParams = {}) =>
    this.http.request<File, any>({
      path: `/v2/payment-details/accounts-payable/${id}/invoice/file`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static downloadInvoiceFilePath = '/v2/payment-details/accounts-payable/${id}/invoice/file'
  static downloadInvoiceFileMethod = 'GET'
  /**
   * No description
   *
   * @tags api-payment-details-controller-v-2
   * @name GetByLinkedFlow
   * @request GET:/api/v2/payment-details/accounts-payable/by-linked-flow
   */
  getByLinkedFlow = (query: GetByLinkedFlowParams, params: RequestParams = {}) =>
    this.http.request<AccountsPayablePaymentWithExpenseData, any>({
      path: `/v2/payment-details/accounts-payable/by-linked-flow`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    })

  static getByLinkedFlowPath = '/v2/payment-details/accounts-payable/by-linked-flow'
  static getByLinkedFlowMethod = 'GET'
}
